import { mallPharmacyState } from './mallPharmacyState';
import { authState } from './authState';
import { drugStoreState } from './drugStoreState';
import { languageState } from './languageState';
import { locationState } from './locationState';
import { selectDoctorState } from './selectDoctorState';
import { userState } from './userState';
import { orderState } from './orderState';
import { taskState } from './taskState';
import { rechargeState } from './rechargeState';
import { webSocketState } from './webSocketState';
import { sideLayoutState } from './sideLayoutState';
// import { combineReducers } from 'redux';
// import { IStoreState, IStateAuth } from 'src/entity/StateEntity';
// import { LOGOUT_SUCCESS } from 'src/constants/ActionTypes';
import { mallCategoryState } from './mallCategoryState';
import { mallBrandState } from './mallBrandState';
import { spuTcmState } from './spuTcmState';
import { spuCpmState } from './spuCpmState';
import { departmentState } from './departmentState';

// /**
//  * combineReducers 辅助函数的作用是:
//  * 把一个由多个不同 reducer 函数作为 value 的 object，
//  * 合并成一个最终的 reducer 函数，然后就可以对这个 reducer 调用 createStore。
//  */
// const appReducer = combineReducers({
//   languageState,
//   authState,
//   userState,
//   locationState,
//   drugStoreState,
//   selectDoctorState,
//   medicineState,
//   orderState,
//   pharmacyState,
//   priceModeState,
//   taskState,
//   rechargeState,
//   webSocketState,
//   sideLayoutState,
// });

// const rootReducer = (state: IStoreState | undefined, action: IStateAuth) => {
//   if (action.type === LOGOUT_SUCCESS) {
//     state = undefined;
//   }
//   return appReducer(state, action);
// };

// export default rootReducer;

export default {
  languageState,
  authState,
  userState,
  locationState,
  drugStoreState,
  selectDoctorState,
  orderState,
  taskState,
  rechargeState,
  webSocketState,
  sideLayoutState,
  mallPharmacyState,
  mallCategoryState,
  mallBrandState,
  spuTcmState,
  spuCpmState,
  departmentState,
};



// WEBPACK FOOTER //
// ./src/redux/reducers/index.ts